import { inject, onBeforeUnmount, onMounted, watch } from 'vue'

/**
 * Sync onboarding wizard footer when inject is available.
 * When absent (AddConnectorStage2), use showFallback in layout.
 */
export function useCrmAuthWizardNav(buildState, deps = []) {
    const wizardNav = inject('onboardingWizardNav', null)

    const syncWizardNav = () => {
        if (!wizardNav) return
        wizardNav.set(buildState())
    }

    watch(deps, syncWizardNav, { deep: true, immediate: true })

    onMounted(() => {
        syncWizardNav()
    })

    onBeforeUnmount(() => {
        if (wizardNav && wizardNav.reset) wizardNav.reset()
    })

    return {
        hasWizardNav: Boolean(wizardNav),
        syncWizardNav,
    }
}
